// Import utilities
const {
	isString,
} = _uo.utility;

import { html, render } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

/**
 * Prompts a dialog to request user data
 *
 * @param {Object} options             The options
 * @param {String} options.summary     The summary
 * @param {String} options.box         The content that requires user data
 * @param {String} options.description The description. Acts as a disclaimer
 * @return {Promise}                    A Promise that resolves after the user adds the user selector
 */
const promptSetDataDialog = ( { summary = '', box = '', description = '' } ) => {
	// Create the element
	const $wrapper = document.createElement( 'div' );
	document.body.append( $wrapper );

	return new Promise( ( resolve, reject ) => {

		render(
			html`
				<ua-builder-user-selector-set-data-dialog
					@automator_user-selector_request-data-dialog_confirm_success=${ () => {
						resolve()
					} }

					@automator_user-selector_request-data-dialog_confirm_fail=${ () => {
						reject()
					} }

					@automator_user-selector_request-data-dialog_cancel=${ () => {
						reject()
					} }
				>

					<div slot="summary">
						${ isString( summary ) ? unsafeHTML( summary ) : summary }
					</div>

					<div slot="box">
						${ isString( box ) ? unsafeHTML( box ) : box }
					</div>

					<div slot="description">
						${ isString( description ) ? unsafeHTML( description ) : description }
					</div>

				</ua-builder-user-selector-set-data-dialog>
			`,
			$wrapper,
			{ host: this }
		);

	} );
}

export default promptSetDataDialog;
